export default __webpack_public_path__ + "center_focus_weak.png";